var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ShDividerLine"},[(_vm.props.text)?_c('span',{staticClass:"ShDividerLine__text"},[_vm._v(_vm._s(_vm.props.text))]):_vm._e(),_c('div',{staticClass:"ShDividerLine__line",style:({ width: _vm.props.width || '100%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }